import { CONVERSATIONS_API } from "@/utils/apiUrl"
import backend from "@/utils/backend"
import * as types from "./mutation_types"
import { passParams } from "@/utils"


export const getAll = ({ commit, state }) => {
    const filter = passParams(state.filter)
    const url = CONVERSATIONS_API + filter
    commit(types.SET_SHOW_LOADING)
    backend({ url, data: null, method: "GET" }).then(({ data }) => {
        commit(types.SET_ITEMS, data?.data ?? data)
        commit(types.SET_IS_SUCCESS)
        commit(types.SET_PAGINATION, { ...data, data: null })
        commit(types.SET_MESSAGE, data.message ?? "Super")
        commit(types.SET_CURRENT_ITEM, null)
    }).catch((err) => {
        commit(types.SET_IS_ERROR)
        commit(types.SET_PAGINATION, null)
        commit(types.SET_SHOW_MESSAGE)
        commit(types.SET_CURRENT_ITEM, null)
        commit(types.SET_MESSAGE, (err?.response?.message ?? err.message ?? err))
    }).finally(() => {
        commit(types.SET_SHOW_MESSAGE)
        commit(types.SET_HIDE_LOADING)

    })
}
export const getPagination = ({ commit, state }) => {
    const nextLinkUrl = state.pagination?.next_page_url ?? null
    if (!nextLinkUrl) {
        return
    }

    // Extraire le numéro de page de l'URL next_page_url
    try {
        const urlObj = new URL(nextLinkUrl)
        const page = urlObj.searchParams.get('page')

        // Construire une nouvelle URL avec les filtres actuels et le numéro de page
        const filter = passParams(state.filter)

        // Si pas de filtres, utiliser l'URL originale
        if (!filter) {
            backend({ url: nextLinkUrl, data: null, method: "GET" }).then(({ data }) => {
                commit(types.SET_APPEND_ITEMS, data?.data ?? data)
                commit(types.SET_IS_SUCCESS)
                commit(types.SET_PAGINATION, { ...data , data: null })
                commit(types.SET_MESSAGE, data.message ?? "Super")
                commit(types.SET_CURRENT_ITEM, null)
            }).catch((err) => {
                commit(types.SET_IS_ERROR)
                commit(types.SET_PAGINATION, null)
                commit(types.SET_SHOW_MESSAGE)
                commit(types.SET_CURRENT_ITEM, null)
                commit(types.SET_MESSAGE, (err?.response?.message ?? err.message ?? err))
            }).finally(() => {
                commit(types.SET_SHOW_MESSAGE)
            })
            return
        }

        // Avec filtres : reconstruire l'URL complète
        const url = CONVERSATIONS_API + filter + '&page=' + page

        backend({ url, data: null, method: "GET" }).then(({ data }) => {
            commit(types.SET_APPEND_ITEMS, data?.data ?? data)
            commit(types.SET_IS_SUCCESS)
            commit(types.SET_PAGINATION, { ...data , data: null })
            commit(types.SET_MESSAGE, data.message ?? "Super")
            commit(types.SET_CURRENT_ITEM, null)
        }).catch((err) => {
            commit(types.SET_IS_ERROR)
            commit(types.SET_PAGINATION, null)
            commit(types.SET_SHOW_MESSAGE)
            commit(types.SET_CURRENT_ITEM, null)
            commit(types.SET_MESSAGE, (err?.response?.message ?? err.message ?? err))
        }).finally(() => {
            commit(types.SET_SHOW_MESSAGE)

        })
    } catch (error) {
        console.error('Erreur lors de la construction de l\'URL de pagination:', error)
        commit(types.SET_IS_ERROR)
        commit(types.SET_MESSAGE, 'Erreur de pagination')
    }
}

export const getAllSearch = ({ commit }, filter = "") => {
    const url = CONVERSATIONS_API + filter

    commit(types.SET_SHOW_LOADING)
    backend({ url, data: null, method: "GET" }).then(({ data }) => {
        commit(types.SET_ITEMS, data?.data ?? data)
        commit(types.SET_IS_SUCCESS)
        commit(types.SET_MESSAGE, data.message ?? "Super")
        commit(types.SET_CURRENT_ITEM, null)
    }).catch((err) => {
        commit(types.SET_IS_ERROR)
        commit(types.SET_SHOW_MESSAGE)
        commit(types.SET_CURRENT_ITEM, null)
        commit(types.SET_MESSAGE, (err?.response?.message ?? err.message ?? err))
    }).finally(() => {
        commit(types.SET_SHOW_MESSAGE)
        commit(types.SET_HIDE_LOADING)

    })
}

export const socketConversation = ({ commit, state, dispatch, rootState }, data) => {


    const oldConversations = state.items;

    // Vérifier si la conversation existe déjà
    const existingConversation = oldConversations?.find(({ id }) => id == data?.id)

    if (existingConversation) {
        // Mise à jour de la conversation existante
        commit(types.SET_ITEMS, [{...data,is_unread:true,message_unread:1}, ...oldConversations.filter(({ id }) => id !== data?.id)])
        if (rootState.conversations.show.item?.id == data?.id) {
            dispatch("messages/list/socketMessage", data?.latest_message, { root: true })
        }
        return
    }

    // Nouvelle conversation : vérifier si elle correspond aux filtres actifs
    const filter = state.filter

    // Si aucun filtre n'est actif, ajouter la conversation
    const hasActiveFilter = filter?.phone ||
                           (filter?.agent_id && filter.agent_id != 0) ||
                           filter?.start_date ||
                           filter?.end_date

    if (!hasActiveFilter) {
        // Pas de filtre actif : ajouter la nouvelle conversation
        commit(types.SET_ITEMS, [{...data,is_unread:true,message_unread:1}, ...state.items])
        dispatch("users/list/getAll", null, { root: true })
        return
    }

    // Vérifier si la nouvelle conversation correspond aux critères de filtre
    let matchesFilter = true

    // Vérifier agent_id
    if (filter?.agent_id && filter.agent_id != 0) {
        if (data?.agent_id != filter.agent_id) {
            matchesFilter = false
        }
    }

    // Vérifier phone (numéro de téléphone)
    if (matchesFilter && filter?.phone) {
        const phone = data?.chat_id?.replace('@c.us', '')?.replace('@s.whatsapp.net', '')
        if (!phone?.includes(filter.phone)) {
            matchesFilter = false
        }
    }

    // Vérifier start_date
    if (matchesFilter && filter?.start_date) {
        const startDate = new Date(filter.start_date)
        const conversationDate = new Date(data?.created_at)
        if (conversationDate < startDate) {
            matchesFilter = false
        }
    }

    // Vérifier end_date
    if (matchesFilter && filter?.end_date) {
        const endDate = new Date(filter.end_date)
        const conversationDate = new Date(data?.created_at)
        if (conversationDate > endDate) {
            matchesFilter = false
        }
    }

    // Ajouter seulement si la conversation correspond au filtre
    if (matchesFilter) {
        commit(types.SET_ITEMS, [{...data,is_unread:true,message_unread:1}, ...state.items])
        dispatch("users/list/getAll", null, { root: true })
    }

}

export const readConversation = ({ commit, state }, socketId) => {

  
    console.log('readConversation est appele avec le data  >> ', socketId )
    const oldConversations = state.items;
    const index = oldConversations?.findIndex(({ id }) => socketId == id)
    if (index == -1) {
        return
    }
   oldConversations[index].is_unread = false
   oldConversations[index].message_unread = 0
   commit(types.SET_ITEMS, oldConversations)
   

    // data.is_read = true
    // data.message_unread = 0
    // commit(types.SET_ITEMS, [ ...oldConversations.filter(({ id }) => id !== data?.id)])

}

export const resetData = ({ commit }) => {
    commit(types.RESET)
}



